$(function() {
	// -------------------------------------------
	// 集計関連処理
	// -------------------------------------------
	window.Nifty = window.Nifty || {};
	window.Nifty.WallPaint = window.Nifty.WallPaint || {};

	Nifty.WallPaint.Tracking = {
		// private
                _isDev: (location.hostname != 'gaiheki-style.com')
		,_isSmp: function() {
			const userAgent = navigator.userAgent;
			return (userAgent.indexOf('iPhone') >= 0 || (userAgent.indexOf('Android') >= 0 && userAgent.indexOf('Mobile') >= 0));
		}
		,_isMyhomeUrl: function(url) {
			return (url.indexOf('/') == 0 || url.indexOf('gaiheki-style.com') >= 0);
		}
		,_initGtag: function() {
			window.dataLayer = window.dataLayer || [];
			window.gtag = function () {
				dataLayer.push(arguments);
			}
			const isApp = navigator.userAgent.includes('NiftyAppMobile')
			// ユーザープロパティ設定(GA4用)
			gtag('set', 'user_properties', {
				'abtest_id': window.Nifty.Gtag?.abTestCustomDimensionValue ?? 'not set',
				'is_app': isApp ? 'true' : 'false'
			});
		}
		,_sendGaPageView: function(url, isNoChangeUrl) {
			if (isNoChangeUrl) {
				// GA4はjsなどによりページ遷移無しでURLが変わるとpage_viewが送信される為、URL変更を伴わない場合のみ送信
				gtag('event', 'page_view', {
					'page_location': url
				});
			}

			if (this._isDev) {
				console.log('[pageview][ga] ' + url + ', ' + isNoChangeUrl);
			}
		}
		,_sendTdPageView: function() {
			if (typeof window.MyhomeTDM != 'undefined') {
				// location.hrefの値が送信される
				MyhomeTDM.Tracking.pageViewTrack('all_pageviews');

				if (this._isDev) {
					console.log('[pageview][td] ' + location.href);
				}
			}
		}
		,_sendGaEvent: function(category, action, label, value) {
			// GA4計測
			let currentPageType = "notset";
			if (typeof this.pageType === "string" || this.pageType instanceof String) {
				currentPageType = this.pageType.toLowerCase();
			}

			const sendValue = (value ? value : 0);
			const sendData = {
				'event': 'custom_event'
				,'ga4_property': label
				,'ga4_reason': currentPageType
				,'ga4_category': category
				,'ga4_action': action
				,'ga4_sendValue': sendValue
			};
			window.dataLayer = window.dataLayer || [];
			dataLayer.push(sendData);

			if (this._isDev) {
				console.log('[event][ga] ' + category + ', ' + action + ', ' + label + ', ' + sendValue);
			}
		}
		,_sendTdEvent: function(mh_event_type, mh_event_category, mh_event_name, mh_event_value, mh_event_psid) {
			/* [注意] cvPoint計測のGAの計測とTDのカラム名の対応
			 * GAの計測  | TDのカラム名
			 * ---------|------------------
			 * category | mh_event_type
			 * action   | mh_event_category
			 * label    | mh_event_psid
			 * value    | - (対応するものなし)
			 * -        | mh_event_value
			 */
			if (typeof window.MyhomeTDM != 'undefined') {
				const table = (this._isSmp() ? 'smp_actions' : 'pc_actions');
				window.MyhomeTDM.Tracking.actionTrack(table, mh_event_type, mh_event_category, mh_event_name, mh_event_value, mh_event_psid);
				if (this._isDev) {
					console.log('[event][td] ' + table + ', ' + mh_event_type + ', ' + mh_event_category + ', ' + mh_event_name + ', ' + mh_event_value + ', ' + mh_event_psid);
				}
			}
		}

		,init: function() {
			this._initGtag();
		}

		// PageView
		,sendPageView: function(url, isNoChangeUrl) {
			this._sendGaPageView(url, isNoChangeUrl);
			this._sendTdPageView();
		}

		// GTM(広告フィード名寄せ)
		,_gtmEventTypeMap: {
			 VIEW_LIST: 'view_item_list'
			,CV0      : 'view_item'
			,CV1      : 'add_to_cart'
		}
		,_sendGtmEvent: function(eventType, itemIds, cvCategory = 'not set') {
			if (!window.Nifty.Data || !window.Nifty.Data.GtmPromoItem || !eventType) {
				return;
			}
			const items = [];
			for (let idx = 0, max = itemIds.length; idx < max; idx++) {
				const item = window.Nifty.Data.GtmPromoItem[itemIds[idx]];
				if (item) {
					items.push(item);
				}
			}
			if (items.length <= 0) {
				return;
			}

			let currentPageType = "notset";
			if (typeof this.pageType === "string" || this.pageType instanceof String) {
				currentPageType = this.pageType.toLowerCase();
			}

			const sendData = {
				'event': eventType,
				'promo_items': items,
				'ga4_reason': currentPageType,
				'ga4_cv_category': cvCategory,
				'_clear': true
			};

			window.dataLayer = window.dataLayer || [];
			dataLayer.push(sendData);

			if (this._isDev) {
				console.log('[event][gtm] sendData:');
				console.log(sendData);
			}
		}
		,sendViewListEvent: function() {
			// 業者一覧表示時
			if (!window.Nifty.Data || !window.Nifty.Data.GtmPromoViewListIds) {
				return;
			}
			this._sendGtmEvent(this._gtmEventTypeMap.VIEW_LIST, window.Nifty.Data.GtmPromoViewListIds);
		}

		// CvPoint
		,_cvPointNumMap: {
			 IMP  : 'cv0'
			,CLICK: 'cv1'
			,FORM_CLICK : 'cv1f'
			,FORM_COMPLETE : 'cv2f'
		}
		,_cvPointTextMap: {
			 IMP  : '詳細ページ閲覧'
			,CLICK: '相場診断ボタンクリック'
			,FORM_CLICK : '相場診断フォームクリック'
			,FORM_COMPLETE : 'フォーム完了'
		}
		,_sendCvPoint: function(cvPoint, cvPointId, url) {
			const cvPointNum = this._cvPointNumMap[cvPoint];
			const cvPointText = this._cvPointTextMap[cvPoint];
			if (cvPointNum && cvPointText) {
				this._sendGaEvent('cvPoint', cvPointNum, cvPointId);
				this._sendTdEvent('CVAction', cvPointNum, cvPointText, (url ? url : location.href), cvPointId);
				// GTM(広告フィード名寄せ)送信はcv0、cv1のみ
				if (cvPointId) {
					if (cvPointNum == 'cv0') {
						this._sendGtmEvent(this._gtmEventTypeMap.CV0, [ cvPointId ], cvPointNum);
					} else if (cvPointNum == 'cv1') {
						this._sendGtmEvent(this._gtmEventTypeMap.CV1, [ cvPointId ], cvPointNum);
					}
				}
			}
		}
		,sendCvPoint: function(data, url, $trigger) {
			const datas = data.split('||');
			const cvPoint = datas[0];
			if (datas.length == 2) {
				if (cvPoint == 'IMP' && $trigger && this._isMyhomeUrl(url)) {
					// 内部リンクの場合、IMPは送信しない(詳細ページ側で送信する為)
					return;
				}
				this._sendCvPoint(cvPoint, datas[1], url);
			}
		}
		,sendFormCvPoint: function(data) {
			const datas = data.split('||');
			const cvPoint = datas[0];
			if (datas.length == 2) {
				// mh_event_psidは無し、mh_event_valueにdataの値を設定
				this._sendCvPoint(cvPoint, '', datas[1]);
			}
		}

		// 404Page
		,_page404Action: {
			 LIST  : 'listView'
			,DETAIL: 'detailsView'
			,OTHER : 'otherView'
		}
		,send404page: function(type) {
			const action = this._page404Action[type];
			const category = '404page';
			const value = location.href;
			if (action) {
				this._sendGaEvent(category, action, value);
				this._sendTdEvent(category, action, '', value, '');
			}
		}

		// 自作 Smart App Banner
		,_sendSelfmadeSmartAppBannerMap: {
			clickLink: '自作SmartAppBanner - リンクをクリック'
		}
		,sendSelfmadeSmartAppBanner: function(action, sendData) {
			if(!(action && action in this._sendSelfmadeSmartAppBannerMap)) return;
			const category = 'selfmadeSmartAppBanner';
			const label = this._sendSelfmadeSmartAppBannerMap[action];
			const isNonInteraction = action == 'showBanner';
			this._sendGaEvent(category, action, label, sendData, isNonInteraction);
			this._sendTdEvent(category, action, label, sendData, '');
		}
	};
	Nifty.WallPaint.Tracking.init();

	// ページ種別取得
	$('#data-tracking-page-type').each(function() {
		Nifty.WallPaint.Tracking.pageType = $(this).attr('data');
	});

	// CVポイント
	$(document).on('click', 'a[data-tracking-cv],button[data-tracking-cv]', function() {
		Nifty.WallPaint.Tracking.sendCvPoint($(this).attr('data-tracking-cv'), $(this).attr('href'), $(this));
	});
	$('input[type="hidden"][data-tracking-cv]').each(function() {
		Nifty.WallPaint.Tracking.sendCvPoint($(this).attr('data-tracking-cv'));
	});

	// CVポイント(相場診断フォーム)
	$('#souoba-shindan-form').on('change', 'select[data-tracking-cv],input[data-tracking-cv]', function() {
		Nifty.WallPaint.Tracking.sendFormCvPoint($(this).attr('data-tracking-cv'));
	});

	// 自作 Smart App Banner 計測;
	$(document).on('click', '[data-tracking-selfmade-smart-app-banner-link]', function() {
		Nifty.WallPaint.Tracking.sendSelfmadeSmartAppBanner('clickLink', location.href);
	});

	// 業者一覧表示イベントの計測
	Nifty.WallPaint.Tracking.sendViewListEvent();
});
